import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';

import { SimulationAgentData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/helpers/types';
import Flex from 'ui/Flex/Flex';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { DetailedAgentPayComponentHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/PayComponent/helpers/types';
import AgentPayComponentHypothesisChip from '../../../Agents/components/PayComponent/AgentPayComponentHypothesisChip';

type Props = CellRendererParams<
    SimulationAgentData, // type of params.data
    DetailedAgentPayComponentHypothesis // type of params.value
> & {
    hrSimulation: HrSimulation;
};

const AgentHypothesisResumeCellRenderer = ({
    value: payComponentHypothesis,
    data,
    hrSimulation,
}: Props): React.ReactElement => (
    <Flex gap="0.5em" alignItems="center">
        {payComponentHypothesis && data && (
            <AgentPayComponentHypothesisChip
                hypothesis={payComponentHypothesis}
                data={data}
                hrSimulation={hrSimulation}
            />
        )}
    </Flex>
);

export default AgentHypothesisResumeCellRenderer;
